import { SummaryHandlerProps, SummaryHandlerReturnArgs } from "../SummaryPage";

export default function useHandleLibrary(props: SummaryHandlerProps): SummaryHandlerReturnArgs | undefined {
    // Prevent misuse
    if (props.request.source.data.type != "library") {
        throw new Error(
            `This hook should only be used when handling files that are already uploaded. Current data type: ${props.request.source.data.type}`,
        );
    }

    const { mediaSource } = props.request.source.data;

    function renderSourceSummaryRow() {
        const source = mediaSource.name;

        return (
            <tr>
                <td>Source</td>
                <td className="break" title={source}>
                    {source}
                </td>
            </tr>
        );
    }

    throw new Error("Unimplemented");
}
